<template>
  <div class="ai-principles-page">
    <!-- Header -->
    <div class="principles-header">
      <div class="principles-header-inner">
        <span class="material-symbols-outlined header-icon">gavel</span>
        <div>
          <h1 class="header-title">Yapay Zeka Kullanım İlkeleri Kılavuzu</h1>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="principles-body">
      <p class="principles-intro">
        Bu kılavuz yargıçların görevleri icabı veya yargısal herhangi bir işlemde yapay zeka araçlarının
        kullanımı konusunda uyması gereken ilkeleri düzenlemektedir.
      </p>

      <ol class="principles-list">
        <li>
          Mahkemeler tarafından kullanıma sunulsun veya sunulmasın, herhangi bir yapay zeka aracı kullanılmadan
          önce, kullanılacak yapay zeka aracının yetenekler ve potansiyel sınırlamaları hakkında temel bilgiye
          sahip olunduğundan emin olunmalıdır.
        </li>
        <li>
          Yapay zeka araçları sorduğunuz her soruyu, girdiğiniz her türlü bilgiyi hatırlamaktadır. Bunlar daha
          sonra başka kullanıcıların sorularına yanıt vermek için kullanılabilmektedir.
        </li>
        <li>
          Yapay zeka araçlarının yargısal işlemler ile alakalı kullanılacağı durumlarda, siber güvenliğin
          sağlandığından emin olunmalıdır. Bu maksatla yapay zekanın yargısal işlemler ile ilgili olarak
          kullanılacağı durumlarda yapay zeka araçlarına Mahkeme ortamında sağlanan ağ hizmetlerinden
          erişilmesi en doğru yaklaşım olacaktır.
        </li>
        <li>
          Bir yapay zeka aracı tarafından size sağlanan herhangi bir bilginin doğruluğu, bu bilgi kullanılmadan
          veya bu bilgiye güvenilmeden önce kontrol edilmelidir.
        </li>
        <li>
          Yapay zeka araçları tarafından sağlanan bilgiler, yanlış, eksik, yanıltıcı olabilir veya güncel
          olmayabilir. Yapay zeka tarafından üretilen cevap veya materyal Kuzey Kıbrıs Türk Cumhuriyeti'nde
          yürürlükte olan mevzuatı kapsadığını belirtse bile, bu doğru olmayabilir. Buna yapay zeka aracının
          halüsinasyon görmesi sonucu ortaya çıkmış olabilecek kaynak ve alıntılar da dahildir.
        </li>
        <li>
          Yapay zeka araçları tarafından üretilen tüm içerikler bağımsız kaynaklardan doğrulanmadan
          kullanılmamalıdır.
        </li>
        <li>
          Yapay zeka araçları halüsinasyon görebilirler. Yapay zeka araçlarının halüsinasyon görmesi aşağıdaki
          formlarda olabilir;
          <ul>
            <li>hayali davalar, alıntılar veya sözler uydurmak ya da var olmayan mevzuat, makaleler veya hukuki metinlere atıfta bulunmak,</li>
            <li>yasa veya yasanın nasıl uygulanabileceği konusunda yanlış ya da yanıltıcı bilgiler vermek, ve</li>
            <li>gerçeğe aykırı olgusal hatalar yapmak.</li>
          </ul>
        </li>
        <li>
          Yargıçlar her zaman huzurlarındaki yargısal işlem ile ilgili layiha, doküman veya sair yargısal işlem
          ile ilgili belgeyi okuyup değerlendirmelidirler. Yapay zeka araçları yardımcı olabilir, ancak
          şahadetin ve olgusal değerlendirmede doğrudan ilgilenmenin yerini almazlar.
        </li>
        <li>
          Yapay zeka araçlarının avukatlar veya avukat tarafından temsil edilmeyen kişiler tarafından da
          kullanılabileceği unutulmamalıdır. Yapay zeka tarafından materyallerde insan gözünün göremeyeceği
          ancak bilgisayar sistemleri tarafından algılanabilen gizli komut ya da saklı materyallerin
          yerleştirilmesi ile oluşan "beyaz metin" olarak adlandırılan sahte içeriklerin de
          bulunabileceğinden ötürü yargısal işlemler sırasında Mahkemenin dikkatine getirilen metin ve/veya
          dokümanların doğruluğu teyit edilmelidir.
        </li>
      </ol>

      <!-- Signature -->
      <div class="principles-signature">
        <span class="material-symbols-outlined signature-icon">account_balance</span>
        <span class="signature-text">YÜKSEK MAHKEME</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AiPrinciples",
});
</script>

<style scoped>
.ai-principles-page {
  /* merkezi token köprüsü — _tokens.scss tek kaynak */
  --sage-primary: var(--sage);
  --sage-accent: var(--gold);
  --sage-bg-main: var(--paper);
  --sage-bg-secondary: #eef0ea;
  --sage-border: var(--rule);
  --sage-text-primary: var(--ink);
  --sage-text-secondary: var(--ink-secondary);
  --sage-text-muted: var(--ink-faint);

  min-height: 100vh;
  background: var(--sage-bg-main);
  display: flex;
  flex-direction: column;
}

/* ── Header ── */
.principles-header {
  background: var(--sage-bg-secondary);
  border-bottom: 3px solid var(--sage-primary);
  padding: 28px 24px;
  flex-shrink: 0;
}

.principles-header-inner {
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 760px;
  margin: 0 auto;
}

.header-icon {
  font-size: 36px;
  color: var(--sage-primary);
  flex-shrink: 0;
}

.header-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--sage-primary);
  margin: 0;
  letter-spacing: 0.01em;
}

/* ── Body ── */
.principles-body {
  max-width: 760px;
  width: 100%;
  margin: 32px auto;
  padding: 0 24px 60px;
}

.principles-intro {
  font-size: 15px;
  line-height: 1.75;
  color: var(--sage-text-secondary);
  margin: 0 0 28px 0;
  padding: 16px 20px;
  background: #fff;
  border-left: 4px solid var(--sage-primary);
  border-radius: 0 8px 8px 0;
  border: 1px solid var(--sage-border);
  border-left: 4px solid var(--sage-primary);
}

/* ── List ── */
.principles-list {
  margin: 0 0 32px 0;
  padding: 0;
  list-style: none;
  counter-reset: principles-counter;
}

.principles-list > li {
  counter-increment: principles-counter;
  position: relative;
  padding: 18px 20px 18px 64px;
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid var(--sage-border);
  border-radius: 10px;
  font-size: 14.5px;
  line-height: 1.75;
  color: var(--sage-text-secondary);
  transition: box-shadow 0.15s;
}

.principles-list > li:hover {
  box-shadow: 0 2px 10px rgba(26, 95, 74, 0.07);
}

.principles-list > li::before {
  content: counter(principles-counter);
  position: absolute;
  left: 18px;
  top: 18px;
  width: 28px;
  height: 28px;
  background: var(--sage-primary);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.principles-list > li > ul {
  margin: 12px 0 0 0;
  padding-left: 20px;
}

.principles-list > li > ul > li {
  font-size: 13.5px;
  line-height: 1.7;
  color: var(--sage-text-muted);
  margin-bottom: 6px;
  list-style: disc;
}

/* ── Signature ── */
.principles-signature {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 20px;
  border-top: 2px solid var(--sage-border);
  margin-top: 8px;
}

.signature-icon {
  font-size: 22px;
  color: var(--sage-primary);
}

.signature-text {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: var(--sage-primary);
  text-transform: uppercase;
}

@media (max-width: 600px) {
  .principles-header { padding: 20px 16px; }
  .header-title { font-size: 17px; }
  .principles-body { padding: 0 14px 40px; margin-top: 20px; }
  .principles-list > li { padding: 14px 14px 14px 54px; }
}
</style>
